/**
 * Check if the specified category and subcategory values and combination of categories
 * is valid i.e. allowed in the data.
 * @param data the dynamic form config json to look in.
 * @param category
 * @param subcategory
 * @returns {T[] | boolean|boolean}
 */
const areValidCategories = (data, category, subcategory) => {
  if (!category || !subcategory) {
    return false;
  }
  const subCats = data.filter(
    cat => cat.value === category)[0].subCategories;
  const subCat = subCats.filter(
    cat => cat.value === subcategory);
  return subCat && subCat.length > 0;
};

/**
 * @param data the dynamic form config json to look in.
 * @param value of the category to fetch the subcategories from.
 * @returns {[]|subCategories|{name, value}|string|null}
 */
const getSubCategories = (data, value) => {
  if (!value) {
    return null;
  }
  const cats = data.filter(category => category.value === value);
  if (!cats || cats.length < 1) {
    return '';
  }
  if (cats[0].subCategories.length < 1) {
    return '';
  }
  return cats[0].subCategories;
};

/**
 * Find out if a give category contains the specified subcategory
 * @param data the dynamic form config json to look in.
 * @param categoryValue value of the category to look in.
 * @param subcategoryValue value of the subcategory to look for
 */
const hasSubCategory = (data, categoryValue, subcategoryValue) => {
  const subcategories = getSubCategories(data, categoryValue);
  if (!subcategories) {
    return false;
  }
  const subcategory = subcategories.filter(sc => sc.value === subcategoryValue)[0];
  return (subcategory !== undefined);
};

/**
 * @param data the dynamic form config json to look in.
 * @param category to look for custom fields under.
 * @param subcategory to look for custom fields under.
 * @returns {string|*}
 */
const getCustomFields = (data, category, subcategory) => {
  if (category && subcategory) {
    const subCats = getSubCategories(data, category);
    if (subCats) {
      const subCat = subCats.filter(c => c.value === subcategory)[0];
      const customFields = (subCat && subCat.customFields) ? subCat.customFields : '';
      if (customFields) {
        return customFields.filter(f => f.position !== 'above');
      }
      return '';
    }
  }
  return '';
};
/**
 * Return and custom fields that are defined as direct children of a category.
 * @param data the dynamic form config json to look in.
 * @param category to look for custom fields under.
 * @returns {string|*}
 */
const getCustomFieldsInCategory = (data, category) => {
  if (category) {
    const cat = data.filter(c => c.value === category)[0];
    if (cat && cat.customFields) {
      return cat.customFields;
    }
    return '';
  }
  return '';
};

/**
 * @param data the dynamic form config json to look in.
 * @param category
 * @param subcategory
 * @returns {Array|*}
 */
const getAboveCustomFields = (data, category, subcategory) => {
  if (category && subcategory) {
    const subCats = getSubCategories(data, category);
    if (subCats) {
      const subCat = subCats.filter(c => c.value === subcategory)[0];
      const customFields = (subCat && subCat.customFields) ? subCat.customFields : '';
      if (customFields) {
        return customFields.filter(f => f.position === 'above');
      }
      return [];
    }
  }
  return [];
};

export default {
  areValidCategories,
  getSubCategories,
  getCustomFields,
  getAboveCustomFields,
  getCustomFieldsInCategory,
  hasSubCategory
};



/** WEBPACK FOOTER **
 ** ./src/components/form/FormConfigUtils.js
 **/